<template>
  <div>
    <v-overlay :value="loader">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <!-- DIALOG -->
    <v-dialog v-model="dialog" max-width="80%">
      <v-card>
        <v-toolbar color="secondary" dark>
          <v-toolbar-title>
            {{$StoreAnnexesInscrUm6p.Label.AjouterPieceJointe}}
          </v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <br/>
          <v-row>
            <v-col cols="12" md="8">
              <v-text-field
                class="pt-0"
                v-model="NomDocument"
                :label="$StoreAnnexesInscrUm6p.Label.TypePiece"
                readonly
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <!--cutom update button AGU-->
              <upload-btn
                class="responsive-btn"
                color="secondary"
                :loading="uploadFileLoading"
                :selectedFileName="this.editedItem.NomFichier"
                :defaultButtonText="
                  $StoreAnnexesInscrUm6p.Label.SelectionnerDocument
                "
                ref="btnupload"
                @file-update="selectFile"
              >
              </upload-btn>
              <small>
                {{ $StoreAnnexesInscrUm6p.Label.FormatsAccptes }}
              </small>
              <br />
              <small>{{ $StoreAnnexesInscrUm6p.Label.TailleMaximale }}</small>

              <v-snackbar
                :timeout="2000"
                color="error"
                elevation="24"
                v-model="snackbar"
              >
                {{ $StoreAnnexesInscrUm6p.Label.TailleMaximaleDepassee }}
              </v-snackbar>
            </v-col>
            <v-col cols="12" md="12">
              <span v-if="editedItem.NomFichier">
                {{ $StoreAnnexesInscrUm6p.Label.FichierSelectionne }} :
              </span>
              <span
                v-if="editedItem.NomFichier"
                style="background-color: lightgray"
                >{{ editedItem.NomFichier }}</span
              >
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" dark @click="close">
            {{ $StoreAnnexesInscrUm6p.Label.Annuler }}
          </v-btn>
          <v-btn
            color="success"
            dark
            :loading="uploadFileLoading"
            @click="save"
          >
            {{ $StoreAnnexesInscrUm6p.Label.Valider }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Liste des annexes -->
    <v-data-table
      v-if="$StoreAnnexesInscrUm6p.ListeAnnexesFirsi && $StoreAnnexesInscrUm6p.ListeAnnexesFirsi.length > 0"
      :headers="orderedHeaders"
      :items="$StoreAnnexesInscrUm6p.ListeAnnexesFirsi"
      class="elevation-1"
      disable-pagination
      hide-default-footer
      :mobile-breakpoint="0"
    >
      <template v-slot:no-data>
        <v-alert :value="true" color="info" :icon="icons.mdiAlert">
          {{ $StoreAnnexesInscrUm6p.Label.ListeVide }}
        </v-alert>
      </template>
      <template v-slot:item="{ item }">
        <tr>
          <th class="text-xs-left col-md-4 col-4">
            {{
              $StoreAnnexesInscrUm6p.ItemLang == "Lang00"
                ? item.NomDocument.Lang00
                : item.NomDocument.Lang01
            }}
          </th>
          <th class="text-xs-left col-md-3 col-4" v-if="isMobile">
            <v-icon
              small
              class="mr-2"
              @click="editItem(item)"
              :disabled="item.Valide"
              v-show="item.Editable"
            >
              {{ icons.mdiPencil }}
            </v-icon>
            <v-icon
              v-if="item.UrlFichier"
              small
              class="mr-2"
              :title="$StoreAnnexesInscrUm6p.Label.AfficherDocument"
              @click="$storeCommun.AfficherAnnexe(item.UrlFichier)"
            >
              {{ icons.mdiEye }}
            </v-icon>
            <v-icon
              small
              @click="deleteItem(item)"
              v-show="item.NomFichier && item.Editable"
              >{{ icons.mdiDelete }}</v-icon
            >
          </th>
          <th class="text-xs-left col-md-3 col-4" style="color: red" v-if="!item.NomFichier">
            {{ $StoreAnnexesInscrUm6p.Label.FichierManquant }}
          </th>
          <th class="text-xs-left breakWord col-md-3 col-4" v-else>
            {{ item.NomFichier }}
          </th>
          <th class=" col-md-3 col-4">
            {{
              item.ObligatoireSoumettre
                ? $StoreAnnexesInscrUm6p.Label.Oui
                : $StoreAnnexesInscrUm6p.Label.Non
            }}
          </th>
          <th
            class="text-xs-left  col-md-3 col-4"
            style="color: red"
            v-if="
              (item.ConformiteElectronique.Id == 4251 ||
                item.ConformiteElectronique.Id == 4299) &&
              item.ConformiteElectronique != null
            "
          >
            {{
              $StoreAnnexesInscrUm6p.ItemLang == "Lang00"
                ? item.ConformiteElectronique.Lang00
                : item.ConformiteElectronique.Lang01
            }}
          </th>
          <th class="text-xs-left col-md-3 col-4" v-else>
            {{
              $StoreAnnexesInscrUm6p.ItemLang == "Lang00"
                ? item.ConformiteElectronique.Lang00
                : item.ConformiteElectronique.Lang01
            }}
          </th>
          <th class="text-xs-left col-md-3 col-4">
            {{ item.NonConformeElectronique }}
          </th>
          <th class="text-xs-left col-md-3 col-4">
            {{ item.Deadline }}
          </th>
          <th class="text-xs-left col-md-3 col-4" v-if="!isMobile">
            <v-icon
              small
              class="mr-2"
              @click="editItem(item)"
              :disabled="item.Valide"
              v-show="item.Editable"
            >
              {{ icons.mdiPencil }}
            </v-icon>
            <v-icon
              v-if="item.UrlFichier"
              small
              class="mr-2"
              :title="$StoreAnnexesInscrUm6p.Label.AfficherDocument"
              @click="$storeCommun.AfficherAnnexe(item.UrlFichier)"
            >
              {{ icons.mdiEye }}
            </v-icon>
            <v-icon
              small
              @click="deleteItem(item)"
              v-show="item.NomFichier && item.Editable"
              >{{ icons.mdiDelete }}</v-icon
            >
          </th>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>
<script>
import {
  mdiPencil,
  mdiEye,
  mdiClose,
  mdiDelete,
  mdiAlert,
  mdiFileDownload,
} from "@mdi/js";
import UploadButton from "@/components/CustomFileUpload";
export default {
  components: {
    "upload-btn": UploadButton,
  },
  data() {
    return {
      isMobile: false,
      // Icon importés depuis mdi/js pour les icones d'édition/suppression
      icons: {
        mdiPencil,
        mdiEye,
        mdiClose,
        mdiDelete,
        mdiFileDownload,
        mdiAlert,
      },
      // store
      $StoreAnnexesInscrUm6p: this.$StoreAnnexesInscrUm6p,

      // dialog
      dialog: false,

      loader: false,
      token: null,
      snackbar: false,
      // Item local
      uploadFileLoading: false,
      editedIndex: -1,
      editedItem: {
        Supprimer: false,
        IdCrypte: null,
        Editable: false,
        AnneeScolaire: {
          Id: null,
          Lang00: null,
          Lang01: null,
        },
        ConformiteElectronique: {
          Id: null,
          Lang00: null,
          Lang01: null,
        },
        ConformitePhysique: {
          Id: null,
          Lang00: null,
          Lang01: null,
        },
        NatureDocument: {
          Id: null,
          Lang00: null,
          Lang01: null,
        },
        NomDocument: {
          Id: null,
          Lang00: null,
          Lang01: null,
        },
        NomFichier: null,
        DonneePieceJointe: null,
        NonConformeElectronique: null,
        NonConformePhysique: null,
        DossierBourseId: null,
        PpId: null,
        TemplateAnnexeFirsi: null,
        TypeDeDocument: {
          Id: null,
          Lang00: null,
          Lang01: null,
        },
      },
    };
  },
  
  mounted() {
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  computed: {
    orderedHeaders() {
      return this.isMobile ? this.$StoreAnnexesInscrUm6p.Label.HeadersPhone 
            : this.$StoreAnnexesInscrUm6p.Label.Headers;
    },
    NomDocument() {
      if (this.$StoreAnnexesInscrUm6p.ItemLang == "Lang01") {
        return this.editedItem.NomDocument.Lang01;
      } else {
        return this.editedItem.NomDocument.Lang00;
      }
    },
  },
  methods: {
    handleResize() {
        this.isMobile = window.innerWidth <= 768;
    },
    ChargerAnnexesResultatBac(id){
      let token = this.$route.query.t;
      if (token) {
        token = token.replace(/\s/g, "+");
        this.token = token;
      }
      this.loader = true;
      let self = this;

      Promise.all([
        this.$StoreAnnexesInscrUm6p
          .ChargerListeAnnexesResultatBac(token, id)
          .then((reponse) => {
            if (reponse.data) {
                this.$StoreAnnexesInscrUm6p.MapperListe(reponse.data);
            }
          }),
      ])
      .then(()=>{
        self.loader = false;
      })
      .catch(()=>{
        self.loader = false;
      })
    },
    ChargerAnnexesInscription() {
      var self = this;
      var token = this.$route.query.t;
      if (token) {
        token = token.replace(/\s/g, "+");
        this.token = token;
      }

      this.loader = true;
      Promise.all([
        this.$StoreAnnexesInscrUm6p
          .ChargerListeAnnexesInscription(token)
          .then((reponse) => {
            if (reponse.data) {
              if (reponse.data.msg) {
                console.log(reponse.data.msg);
              } else {
                this.$StoreAnnexesInscrUm6p.MapperListe(
                  reponse.data.listeAnnexes
                );
              }
            }
          }),
      ])
        .then(function () {
          self.dialog = false;
          self.loader = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    editItem(item) {
      this.editedIndex =
        this.$StoreAnnexesInscrUm6p.ListeAnnexesFirsi.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },
    deleteItem(item) {
      if (confirm("Etes-vous sûr de vouloir supprimer ce fichier ?")) {
        // on récupère l'item depuis le store
        this.editedIndex =
          this.$StoreAnnexesInscrUm6p.ListeAnnexesFirsi.indexOf(item);
        // on affecte l'item local pour récupèrer les valeurs
        this.editedItem = Object.assign({}, item);

        var self = this;
        Promise.all([
          // Appel de l'api de suppression de la PJ
          this.$storeDemandeBourse
            .DeleteFichier(this.editedItem, this.token)
            .then((reponse) => {
              if (reponse) {
                this.ParseDtoToEditedItem(reponse.data);
                this.editedItem.ConformiteElectronique = {
                  Id: null,
                  Lang00: null,
                  Lang01: null,
                };
                Object.assign(
                  this.$StoreAnnexesInscrUm6p.ListeAnnexesFirsi[
                    this.editedIndex
                  ],
                  this.editedItem
                );
              }
            })
            .catch((error) => {
              console.log(error);
            }),
        ]).then(function () {
          // RAZ de editeditem
          self.close();
        });
      }
    },
    // Fonction appelé quand un fichier sélectionné ou déselectionné dans le 'upload-btn'
    async selectFile(file) {
      if (file) {
        if (file.size > 4173649) {
          this.editedItem.NomFichier = "";
          this.editedItem.DonneePieceJointe = null;
          this.snackbar = true;
        } else {
          this.uploadFileLoading = true;
          this.editedItem.NomFichier = file.name;
          await this.readFile(file, this.editedItem);
          setTimeout(this.stopLoadinMode, 2000);
        }
      } else {
        this.editedItem.NomFichier = "";
        this.editedItem.DonneePieceJointe = null;
      }
    },

    // Lire le contenu d'un fichier la data de l'élément en cours
    readFile(file, monFichier) {
      var reader = new FileReader();

      // Listener de fin de lecture
      reader.onloadend = function () {
        monFichier.DonneePieceJointe = btoa(reader.result);
      };

      // Lancer la lecture du fichier

      reader.readAsBinaryString(file);
    },

    // Arrêter
    stopLoadinMode() {
      this.uploadFileLoading = false;
    },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign(
          {},
          {
            Supprimer: false,
            IdCrypte: null,
            Editable: false,
            AnneeScolaire: {
              Id: null,
              Lang00: null,
              Lang01: null,
            },
            ConformiteElectronique: {
              Id: null,
              Lang00: null,
              Lang01: null,
            },
            ConformitePhysique: {
              Id: null,
              Lang00: null,
              Lang01: null,
            },
            NatureDocument: {
              Id: null,
              Lang00: null,
              Lang01: null,
            },
            NomDocument: {
              Id: null,
              Lang00: null,
              Lang01: null,
            },
            NomFichier: null,
            DonneePieceJointe: null,
            NonConformeElectronique: null,
            NonConformePhysique: null,
            DossierBourseId: null,
            PpId: null,
            TemplateAnnexeFirsi: null,
            TypeDeDocument: {
              Id: null,
              Lang00: null,
              Lang01: null,
            },
          }
        );
        this.editedIndex = -1;
      }, 300);
    },

    save() {
      if (this.editedIndex > -1) {
        var self = this;
        this.uploadFileLoading = false;
        this.editedItem.Supprimer = false;
        Promise.all([
          // Sauvegarder le fichier, appelle api
          this.$storeDemandeBourse
            .UploadFichier(this.editedItem, this.token)
            .then((reponse) => {
              if (reponse && reponse.data) {
                this.ParseDtoToEditedItem(reponse.data);
                Object.assign(
                  this.$StoreAnnexesInscrUm6p.ListeAnnexesFirsi[
                    this.editedIndex
                  ],
                  this.editedItem
                );
              } else {
                console.log("annexe pas enregistrée");
              }
            })
            .catch((error) => {
              console.log("error");
              console.log(error);
            }),
        ]).then(function () {
          self.close();
          self.$refs.btnupload.resetClick();
        });
      }
    },
    ParseDtoToEditedItem(dto) {
      this.editedItem =
        this.$StoreAnnexesInscrUm6p.ElementToAnnexesFirsiDto(dto);
    },
  },
};
</script>
<style scoped>
.v-dialog__content {
  align-items: start !important;
}

.breakWord {
  word-wrap: break-word;
  word-break: break-word;
}
</style>
